import React from 'react';
import Circle from './Circle';

const WebSite = () =>
    <Circle>
        <svg fill="currentColor" focusable="false" width="18px" height="18px" x="11" y="9" viewBox="-3.63064 -66.0327 1030.76 962.035">
            <path d="M960 864.192h-896c-35.1836 0 -64 -28.7998 -64 -64v-544.192c0 -35.1836 28.8164 -63.9834 64 -63.9834h416v-96.208h-160c-17.6641 0 -32 -14.3359 -32 -32s14.3359 -32 32 -32h384c17.6641 0 32 14.3359 32 32c0 17.6641 -14.3359 32 -32 32h-160v96.208h416 c35.1836 0 64 28.7998 64 63.9834v544.192c0 35.2002 -28.8164 64 -64 64zM960 256h-896v544.192h896v-544.192z" />
        </svg>
    </Circle>

export default WebSite;

